"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function useDlogEvent(eventName) {
    const gameBridge = (0, useGameBridge_1.default)();
    return (0, react_1.useCallback)((columns) => {
        gameBridge.dlogEvent({
            event: eventName,
            columns,
        });
    }, [gameBridge]);
}
exports.default = useDlogEvent;
